import { render, staticRenderFns } from "./PlaceSearch.vue?vue&type=template&id=b5540ab0&scoped=true&"
import script from "./PlaceSearch.vue?vue&type=script&lang=js&"
export * from "./PlaceSearch.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSearch.vue?vue&type=style&index=0&id=b5540ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5540ab0",
  null
  
)

export default component.exports